import { formatDate, formatNumber, formatPercent } from "./formatters.ts";
import type { AdminSellerMetric } from "./types.ts";

export function SellersTable({
  sellers,
  loading,
}: {
  sellers: AdminSellerMetric[];
  loading: boolean;
}) {
  return (
    <section className="admin-section admin-section-wide">
      <div className="admin-section-head">
        <h2>Vendedores</h2>
        <span>{sellers.length} ativos</span>
      </div>
      <div className="admin-table-wrap">
        <table className="admin-table">
          <thead>
            <tr>
              <th>Vendedor</th>
              <th>Leads</th>
              <th>Abertos</th>
              <th>Contato</th>
              <th>Resp.</th>
              <th>Atividades</th>
            </tr>
          </thead>
          <tbody>
            {sellers.length ? sellers.map((seller) => (
              <tr key={seller.seller_id}>
                <td>
                  <strong>{seller.seller_email}</strong>
                  <span>{seller.last_activity_at ? `Última atividade ${formatDate(seller.last_activity_at)}` : "Sem atividade recente"}</span>
                </td>
                <td>{formatNumber(seller.leads_total)}</td>
                <td>{formatNumber(seller.leads_open)}</td>
                <td>{formatNumber(seller.leads_contacted)}</td>
                <td>{formatPercent(seller.response_rate)}</td>
                <td>{formatNumber(seller.activities_total)}</td>
              </tr>
            )) : (
              <tr>
                <td colSpan={6}>{loading ? "Carregando..." : "Nenhum vendedor encontrado."}</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </section>
  );
}
